import { isEmptyObject } from "../../../utils/tests";
import { LeaguesQuery } from '../types';

/**
 * typeguard for LeaguesQuery
 * @param LeaguesQuery object passed to transformer
 */
export const isValidLeagues = (obj: LeaguesQuery): boolean => Boolean(obj?.data?.getCompetitionTeam && !isEmptyObject(obj.data.getCompetitionTeam));
